<div class="push-notification-panel animated fadeIn">
    <div class="notification-panel-content d-flex">
        <bell-icon-svg></bell-icon-svg>
        <div>
            <h3>
                {{ promptTitle() }}
            </h3>
            <caption>
                {{
          promptMessage()
        }}
            </caption>

            <div class="d-flex align-items-center">
                <span class="accept-btn" (click)="onSubscribe()">
                    {{ promptAcceptButtonLabel() }}
                </span>
                <span class="reject-btn" (click)="onUnsubscribe()">
                    {{ promptRejectButtonLabel() }}
                </span>
            </div>
        </div>
    </div>
</div>